import { socConflictCopyFromError } from '../../components/visit/socConflictCopy';
import {
  getSurfaceableError,
  parse4xxApiError,
  type FieldValidationError,
} from '../../utils/apiErrorDetail';

export const ROGER_GENERIC_ONBOARDING_MESSAGE =
  'Unable to onboard patient in Roger. Please try again.';

export type { FieldValidationError };

interface RogerOnboardingErrorResult {
  message: string;
  surfaceable?: boolean;
  errorCode?: string;
}

/**
 * Maps an error thrown by the Roger onboarding API to a user-facing message.
 *
 * Surfaceable business errors (HTTP 409) take priority and are shown verbatim.
 * Known 4xx responses (archived intake, already pushed, missing episode fields,
 * etc.) are shown verbatim. 5xx and unparseable errors use generic copy.
 */
export function parseRogerOnboardingError(
  error: unknown
): RogerOnboardingErrorResult {
  const socCopy = socConflictCopyFromError(error);
  if (socCopy) {
    return { message: socCopy };
  }

  const surfaceable = getSurfaceableError(error);
  if (surfaceable) {
    return {
      message: surfaceable.message,
      surfaceable: true,
      errorCode: surfaceable.errorCode,
    };
  }

  const { message } = parse4xxApiError(error);
  if (message) {
    return { message };
  }

  return { message: ROGER_GENERIC_ONBOARDING_MESSAGE };
}
